<template>
  <CRow>
    <CCol col="12">
      <CCard>
        <CCardHeader>
          <div class="row">
            <CCol sm="6" class="align-self-center">
              <strong>{{ $lang.branch.title }}</strong>
            </CCol>
            <CCol sm="6" class="align-self-center">
              <div class="text-sm-right mt-3 mt-sm-0">
                <CButton
                    color="primary"
                    v-on:click="createTableRow"
                    v-if="checkPermission('create-branch')"
                    style="margin-right: 10px"
                >
                  {{ $lang.buttons.general.crud.create }}
                </CButton>
                <CButtonGroup class="file-export">
                  <CButton color="secondary" disabled>
                    {{ $lang.buttons.export.title }}
                  </CButton>
                  <CButton
                      color="danger"
                      v-c-tooltip="$lang.buttons.export.pdf"
                      v-on:click="exports(self, 'pdf', module, 'Branch')"
                  >
                    <i class="fas fa-file-pdf"></i>
                  </CButton>
                  <VueJsonToCsv
                      class="btn btn-success"
                      v-c-tooltip="$lang.buttons.export.excel"
                      :json-data="json_data"
                      :labels="json_label"
                      :csv-title="json_title"
                  >
                    <i class="fas fa-file-excel"></i>
                  </VueJsonToCsv>
                </CButtonGroup>
              </div>
            </CCol>
          </div>
        </CCardHeader>
        <CCardBody>
          <CAlert
              :color="messageColor"
              closeButton
              :show.sync="dismissCountDownS"
              fade
          >{{ alertMessage }}
          </CAlert
          >
          <v-server-table
              :columns="columns"
              url="/branch/list"
              :options="options"
              ref="myTable"
              @loaded="exports(self, 'Excel', module, 'Branch')"
          >
            <template #isHeadOffice="data">
              <CBadge :color="statusBudget(data.row.isHeadOffice)">{{ data.row.isHeadOffice }}</CBadge>
            </template>
            <template #branchName="data">
              <span :title="data.row.branchName">{{
                  trimfunction(data.row.branchName, 50)
                }}</span>
            </template>
            <template #companyName="data">
              <span :title="data.row.companyName">{{
                  trimfunction(data.row.companyName, 50)
                }}</span>
            </template>
            <template #isHeadOffice="data">
              <CBadge :color="statusBudget(data.row.isHeadOffice)">{{ data.row.isHeadOffice }}</CBadge>
            </template>
            <template #address="data">
              <span :title="data.row.address">{{
                  trimfunction(data.row.address, 150)
                }}</span>
            </template>

          </v-server-table>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import Vue from "vue";
import VueForm from "vue-form";
import store from "/src/store/store.js";
import {branch, users} from "/src/store/url.js";
import {Mixin} from "/src/mixins/index.js";
import options from "/src/validations/validations.js";
import {ServerTable} from "vue-tables-2";
import VueSweetalert2 from "vue-sweetalert2";
import moment from "moment";
import "vue-simple-range-slider/dist/vueSimpleRangeSlider.css";
import VueJsonToCsv from "vue-json-to-csv";

Vue.use(VueSweetalert2);
Vue.use(ServerTable, {}, false);
Vue.use(VueForm, options);

export default {
  name: "BranchItem",
  mixins: [Mixin],
  components: {
    VueJsonToCsv,
  },
  data() {
    return {
      json_data: [],
      json_label: {},
      messageColor: "success",
      json_title: "",
      toggleFilterValue: false,
      range: [0, 1000000],
      number: 1,
      err_msg: "",
      largeModal: false,
      submitType: "",
      alertMessage: "test",
      showAlert: false,
      dismissCountDown: 0,
      dismissCountDownS: 0,
      self: this,
      msg: "",
      activePage: 1,
      module: branch,
      moduleUser: users,
      filter: {
        type: "",
      },
      columns: ["branchName", "companyName", "isHeadOffice", "address"], //'status'
      data: [],
      userOptions: [],
      options: {
        headings: {
          branchName: this.$lang.branch.table.branchName,
          companyName: this.$lang.branch.table.companyName,
          isHeadOffice: this.$lang.branch.table.isHeadOffice,
          address: this.$lang.branch.table.address,
          // actions: this.$lang.common.general.actions,
        },
        editableColumns: ["branchName", "companyName", "isHeadOffice", "address"],
        sortable: ["branchName", "companyName", "isHeadOffice", "address"],
        filterable: ["branchName", "companyName", "isHeadOffice", "address"],
      },
    };
  },
  mounted() {
    let self = this;
    self.dismissCountDown = 0;
    self.dismissCountDownS = 0;
    this.$root.$on("alert", (arg1, arg2) => {
    });
    if (localStorage.getItem("showAlert") !== "") {
      this.setAlert(true);
    }
    this.setAlert(false);
    localStorage.setItem("showAlert", "");
    // axios.get(this.listUrlApi(this.moduleUser)).then((response) => {
    //   response.data.map(function (value, key) {
    //     self.userOptions.push({ value: value.id, label: value.username });
    //   });
    // });
  },
  methods: {
    /* get from child component */
    getHumanDate: function (date) {
      return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
    },
    switchFilter(show) {
      this.toggleFilterValue = show;
    },
    setAlert(value) {
      this.showAlert = value;
    },
    deletePopup(item) {
      this.$swal({
        title: this.$lang.common.delete_swal.are_you,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#e55353",
        confirmButtonText: this.$lang.common.delete_swal.yes_delete,
        cancelButtonText: this.$lang.common.delete_swal.cancel,
      }).then((result) => {
        if (result.value) {
          let self = this;
          axios
              .delete(this.deleteUrlWeb(this.module, item), self)
              .then(function (response) {
                if (response.data.status === 200) {
                  self.$refs.myTable.refresh();
                  self.alertMessage = response.data.message;
                  self.dismissCountDownS = 10;
                  self.messageColor = "success";
                } else {
                  self.$refs.myTable.refresh();
                  self.alertMessage = response.data.message;
                  self.messageColor = "danger";
                  self.dismissCountDownS = 10;
                }
              });
        }
      });
    },
    createTableRow() {
      this.$router.push({name: "Branch Create"});
    },
    editTableRow(item) {
      this.$router.push({path: `branch/edit/${item}`});
    },
    viewTableRow(item) {
      this.$router.push({path: `branch/view/${item}`});
    },
    applyFilter() {
      let reqObj = {
        type:
            this.filter.type !== null && Object.keys(this.filter.type).length > 0
                ? this.filter.type.value
                : "",
      };
      store.commit("showLoader", true); // Loader Start
      this.$refs.myTable.customQueries = reqObj;
      this.$refs.myTable.refresh();
    },
    resetFilter() {
      this.filter.type = {};
      store.commit("showLoader", true);
      this.$refs.myTable.customQueries = {};
      this.$refs.myTable.refresh();
    },
  },
};
</script>
